import React, { useState, useContext } from 'react'
import { Modal, Spinner, Button } from 'react-bootstrap';
import { FiSearch, FiUsers, FiX } from 'react-icons/fi';

import { AppContext } from '../AppContext';
import { tre } from '../trebus'
import ZList from './../components/ZList'

/**
 * SelectUser Modal
 *
 * @param {boolean} show - Whether to show the modal
 * @param {function} toggle - Function to toggle modal visibility
 * @param {function} onSelect - Callback when a user is selected
 */
export default function SelectUser({ show, toggle, onSelect }) {

    const [users, setUsers] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const context = useContext(AppContext);

    const loadUsers = (p = { page: 1, search: '' }) => {
        setIsLoading(true);
        tre.api('GET', '/companies/' + context.idCompany + '/users', {
            context: context,
            params: {
                page: p.page,
                rows: 10,
                name: p.search,
            },
            success: (r) => {
                setUsers(r);
                setIsLoading(false);
            },
            error: () => setIsLoading(false)
        });
    }

    return (
        <Modal size="lg" show={show} onHide={toggle} centered>
            <Modal.Header closeButton style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #e9ecef' }}>
                <Modal.Title className="d-flex align-items-center" style={{ color: '#202124', fontWeight: 500 }}>
                    <div
                        className="d-flex align-items-center justify-content-center rounded-circle me-3"
                        style={{ width: '40px', height: '40px', backgroundColor: '#e8f0fe', color: '#1a73e8' }}
                    >
                        <FiSearch size={18} />
                    </div>
                    Buscar Usuario
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="p-4">
                {isLoading && users.data?.length === 0 ? (
                    <div className="text-center py-5">
                        <Spinner animation="border" style={{ color: '#1a73e8' }} />
                        <p className="mt-3 text-muted">Cargando usuarios...</p>
                    </div>
                ) : (
                    <ZList
                        search
                        rows={users.data}
                        page={users.current_page}
                        pages={users.last_page}
                        count={users.total}
                        onFetch={loadUsers}
                        onSelect={onSelect}
                        showHeaders={true}
                        cols={[
                            {
                                field: 'full_name',
                                caption: 'Usuario',
                                md: 8,
                                align: 'L',
                                value: r => (
                                    <div className="d-flex align-items-center">
                                        <div
                                            className="d-flex align-items-center justify-content-center rounded-circle me-3"
                                            style={{
                                                width: '36px',
                                                height: '36px',
                                                backgroundColor: '#e8f0fe',
                                                color: '#1a73e8',
                                                fontSize: '14px',
                                                fontWeight: 600,
                                                flexShrink: 0
                                            }}
                                        >
                                            {(r.name || '?').charAt(0).toUpperCase()}
                                        </div>
                                        <div>
                                            <div style={{ fontWeight: 500, color: '#202124' }}>
                                                {r.surname ? `${r.surname}, ${r.name}` : r.name}
                                            </div>
                                            {r.mobile && (
                                                <small className="text-muted">{r.mobile}</small>
                                            )}
                                        </div>
                                    </div>
                                )
                            },
                            {
                                field: 'go',
                                caption: 'Parada',
                                md: 4,
                                value: r => r.go ? (
                                    <span
                                        style={{
                                            backgroundColor: '#e8f0fe',
                                            color: '#1a73e8',
                                            padding: '4px 10px',
                                            borderRadius: '12px',
                                            fontSize: '13px',
                                            fontWeight: 500
                                        }}
                                    >
                                        {r.go.name}
                                    </span>
                                ) : (
                                    <span className="text-muted">-</span>
                                )
                            },
                        ]}
                    />
                )}
            </Modal.Body>

            <Modal.Footer style={{ backgroundColor: '#f8f9fa', borderTop: '1px solid #e9ecef' }}>
                <Button variant="light" onClick={toggle}>
                    <FiX className="me-2" />
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
